import React from 'react';
import { Mail, MapPin, Clock, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-warm-charcoal text-warm-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-playfair font-light mb-3">
              Kensetsu Limited
            </h3>
            <p className="text-warm-white/50 italic mb-4 font-manrope">
              Where Dimension Takes Form
            </p>
            <p className="text-warm-white/70 leading-relaxed font-manrope text-sm">
              Creating custom furniture solutions that transform spaces into works of art.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-manrope font-semibold mb-6 text-gold">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('about');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-warm-white/70 hover:text-gold transition-colors duration-300 font-manrope text-sm"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('services');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-warm-white/70 hover:text-gold transition-colors duration-300 font-manrope text-sm"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('gallery');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-warm-white/70 hover:text-gold transition-colors duration-300 font-manrope text-sm"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-warm-white/70 hover:text-gold transition-colors duration-300 font-manrope text-sm"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-manrope font-semibold mb-6 text-gold">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-gold mt-1 flex-shrink-0" />
                <a
                  href="https://www.google.com/maps/place/Kensetsu+Limited/@18.0119657,-76.7962534,17z/data=!4m14!1m7!3m6!1s0x8edb3f5a7868b507:0x3d6d645ea51e377b!2sKensetsu+Limited!8m2!3d18.0119657!4d-76.7962534!16s%2Fg%2F11xfr1n6mw!3m5!1s0x8edb3f5a7868b507:0x3d6d645ea51e377b!8m2!3d18.0119657!4d-76.7962534!16s%2Fg%2F11xfr1n6mw!5m1!1e1?entry=ttu&g_ep=EgoyMDI2MDEwNC4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-warm-white/70 hover:text-gold transition-colors duration-300 font-manrope text-sm"
                >
                  1 Suthermere Road<br />Kingston, Jamaica
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-gold mt-1 flex-shrink-0" />
                <a
                  href="mailto:Kensetsulimited@gmail.com"
                  className="text-warm-white/70 hover:text-gold transition-colors duration-300 font-manrope text-sm break-all"
                >
                  Kensetsulimited@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-gold mt-1 flex-shrink-0" />
                <div className="text-warm-white/70 font-manrope text-sm space-y-1">
                  <a href="tel:+18766715240" className="block hover:text-gold transition-colors duration-300">876-671-5240</a>
                  <a href="tel:+18763910515" className="block hover:text-gold transition-colors duration-300">876-391-0515</a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Clock size={18} className="text-gold mt-1 flex-shrink-0" />
                <span className="text-warm-white/70 font-manrope text-sm">
                  Mon-Fri: 8:30 AM - 4:30 PM
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-warm-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-warm-white/50 font-manrope text-sm">
              &copy; {new Date().getFullYear()} Kensetsu Limited. All rights reserved.
            </p>
            <p className="text-warm-white/50 font-manrope text-sm">
              Designed for Elegant Living
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
